module.exports = __webpack_public_path__ + "static/media/img1-2.9927812c.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pina/nutricheck_suelo/B/img1-2.png
// module id = 2324
// module chunks = 3